var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_182769",
    "data-name": "Group 182769",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.993,
    height: 12.012,
    viewBox: "0 0 11.993 12.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49844",
    "data-name": "Path 49844",
    d: "M49.848,6.555,48.639,5.346a1.25,1.25,0,0,0-1.777,0L46,6.207l2.987,2.987.861-.861A1.25,1.25,0,0,0,49.848,6.555Z",
    transform: "translate(-38.226 -4.975)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49845",
    "data-name": "Path 49845",
    d: "M5.037,52.125a.393.393,0,0,0,.092.366.382.382,0,0,0,.366.092l3.225-.916L5.935,48.9Z",
    transform: "translate(-5.023 -40.585)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49846",
    "data-name": "Path 49846",
    d: "M0,0H8.254V4.344H0Z",
    transform: "translate(1.327 7.59) rotate(-45)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2418c9dbadb8fe2a7d8048783cfe44e2.svg";
export { ForwardRef as ReactComponent };